import { useProjectStore } from '@/modules/cleepo/stores/project.store';
import type { NavigationGuard } from 'vue-router';

export const projectMiddlewares: Record<string, NavigationGuard> = {
  hasPendingRequiredConfigurationTasks: async (to, from, next) => {
    const projectStore = useProjectStore();
    if (projectStore.hasPendingRequiredConfigurationTasks) {
      return next({ name: 'CleepoWizardConfigurationTasksView' });
    }

    next();
  },
};
